const BASE = {
	BASE_URL: '/',
	APP_NAME: 'Rumis Hiring',
	APP_SHORT_NAME: 'RMK Hiring',
};

export type CONFIG_TYPE = typeof BASE & {
	SERVER: string;
	WSS: string;
};

export const CONFIG = {
	...BASE,
	SERVER: process.env.REACT_APP_SERVER as string,
	WSS: process.env.REACT_APP_WSS as string,
	API_SERVER: (process.env.REACT_APP_SERVER as string) + '/api',
};

window.CONFIG = CONFIG;
